import customerOrderReviews_zh from './customerOrderReviews_zh';

const zhLocales = { ...customerOrderReviews_zh };
const zhLocaleContext = require.context('./zh-CN', false, /\.js$/);
zhLocaleContext.keys().forEach((file) => {
  const moduleLocale = zhLocaleContext(file).default;
  Object.assign(zhLocales, moduleLocale);
});
export default zhLocales;
